import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import BedManagementSvc from "@/services/BedManagementService";
import {
  BedManagementListFilter,
  BedManagementMasters,
  BedManagementMeta,
  BedManagementRow
} from "@/types/bedManagement";

let permintaanKe = 0;

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "bed-management"
})
class BedManagementModule extends VuexModule {
  items: BedManagementRow[] = [];
  currentItem: BedManagementRow | null = null;
  masters: BedManagementMasters | null = null;
  loading = false;
  meta: BedManagementMeta | null = null;

  @Mutation SET_ITEMS(val: BedManagementRow[]) {
    this.items = val || [];
  }

  @Mutation SET_CURRENT_ITEM(val: BedManagementRow | null) {
    this.currentItem = val;
  }

  @Mutation SET_MASTERS(val: BedManagementMasters | null) {
    this.masters = val;
  }

  @Mutation SET_META(val: BedManagementMeta | null) {
    this.meta = val || null;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async fetchMasters() {
    if (this.masters) return;
    try {
      const dt = await BedManagementSvc.masters();
      this.SET_MASTERS(dt.data.data || null);
    } catch {
      this.SET_MASTERS(null);
    }
  }

  @Action async fetchList(params: BedManagementListFilter = {}) {
    const token = ++permintaanKe;
    this.SET_LOADING(true);

    try {
      const dt = await BedManagementSvc.list(params);
      if (token !== permintaanKe) return;
      this.SET_ITEMS(dt.data.data || []);
      this.SET_META(dt.data.meta || null);
    } catch {
      if (token !== permintaanKe) return;
      this.SET_ITEMS([]);
      this.SET_META(null);
    }

    if (token === permintaanKe) this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await BedManagementSvc.find(id);
      this.SET_CURRENT_ITEM(dt.data.data || null);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }
    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_ITEMS([]);
    this.SET_CURRENT_ITEM(null);
    this.SET_META(null);
  }
}

export const storeBedManagement = getModule(BedManagementModule);
